/**
 * Ops Center translations - English
 */
export const opsCenterEn = {
  title: 'Ops Center',
  subtitle: 'IT and internal operations governance workbench',

  m365Dormant: {
    title: 'M365 Dormant Accounts',
    subtitle: 'Identify Microsoft 365 accounts inactive for extended periods',

    statusBar: {
      lastSync: 'Last sync',
      neverSynced: 'Never synced. Click the button to trigger.',
      success: 'Success',
      running: 'Syncing...',
      failed: 'Failed',
      timeout: 'Sync timeout',
      totalUsers: '{count} users',
      changedUsers: '{count} changed',
      syncButton: 'Sync now',
      syncRunningSeconds: 'Running for {seconds}s',
      partialBanner:
        'Syncing new data ({seconds}s elapsed). Showing data as of last sync ({snapshotAt}).',
      failedBanner:
        'Sync failed: {errorCode}. Showing data from last successful sync ({snapshotAt}).',
    },

    filters: {
      inactiveDaysLabel: 'Inactive days ≥',
      accountAgeMinLabel: 'Account age ≥',
      keyword: 'Email / Display Name / Mail',
      accountEnabled: 'Enabled',
      accountEnabledAll: 'All',
      accountEnabledTrue: 'Enabled',
      accountEnabledFalse: 'Disabled',
      hasLicense: 'License',
      hasLicenseAll: 'All',
      hasLicenseTrue: 'Has license',
      hasLicenseFalse: 'No license',
      licenseType: 'License Type',
      licenseTypeAll: 'All types',
      exportCsv: 'Export CSV',
    },

    table: {
      column: {
        email: 'Email (UPN)',
        displayName: 'Display Name',
        department: 'Department',
        accountEnabled: 'Enabled',
        license: 'License',
        accountCreated: 'Created',
        lastSignIn: 'Last Sign-In',
        lastAnyActivity: 'Last Activity',
        daysInactive: 'Days Inactive',
      },
      noActivity: 'No record',
      noActivityTooltip: 'License may be insufficient or never signed in',
      noActivityNew: 'New, not signed in',
      noActivityNewTooltip: 'Account created {daysAgo} days ago, never signed in yet',
      noActivityOld: 'Never signed in',
      noActivityOldTooltip: 'Account created {daysAgo} days ago, never signed in',
      noLicense: 'None',
      licensesCountSuffix: '+{count}',
    },

    drawer: {
      tab: {
        overview: 'Overview',
        timeline: 'Activity Timeline',
      },
      signInSection: 'Sign-In Activity (near-real-time, ≤ 1h delay)',
      serviceSection: 'Service Activity (Microsoft offline, 24-48h delay)',
      licenseSection: 'Licenses',
      missingFromLatestTag: 'Not seen in latest sync — may have been disabled',
      accountCreatedAt: 'Account created',
      accountAgeDays: 'Created {days} days ago',
      timelineEmpty: 'No activity changes recorded for this user',
    },

    trend: {
      sectionTitle: 'Dormant Trend',
      thresholdLabel: 'Threshold',
      thresholdDays: '{n} days',
      includeNeverSignedIn: 'Include never signed-in',
      empty: 'No sync history yet',
      approxTooltip: 'Approximate (30-day bucket aggregation)',
    },

    sync: {
      toast: {
        successTotal:
          'Sync complete: {total} users, {dormant} dormant (at {threshold} days threshold)',
        failed: 'Sync failed: {errorCode} {errorMessage}',
      },
    },

    error: {
      AZURE_CREDENTIAL_MISSING:
        'Please ask Ops to set AZURE_TENANT_ID / AZURE_CLIENT_ID / AZURE_CLIENT_SECRET in .env',
      GRAPH_INSUFFICIENT_SCOPE:
        'Azure App Registration is missing required scope (AuditLog.Read.All or Reports.Read.All). Please add and admin-consent in Azure Portal.',
      REPORTS_OBFUSCATED:
        'M365 reports are obfuscated. In M365 Admin Center → Settings → Org settings → Reports, uncheck "Display concealed names in all reports".',
      SYNC_IN_PROGRESS: 'A sync is already in progress',
      NO_SUCCESSFUL_SYNC: 'No M365 data synced yet. Click "Sync now" to begin.',
      EXPORT_TOO_LARGE: 'Export exceeds the 50,000-row limit. Narrow your filter.',
      USER_NOT_FOUND: 'User not found',
      LIST_LOAD_FAILED: 'Failed to load list',
    },

    empty: {
      filtered: 'No dormant accounts under current filters',
      noBatch: 'No M365 data synced yet. Click "Sync now" to begin.',
    },

    common: {
      retry: 'Retry',
      close: 'Close',
    },
  },
};
